// extracted by mini-css-extract-plugin
export var underlinedLink = "_o0-0";